"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalError = exports.ErrorCode = exports.InternalErrorTable = exports.buildErrorCodeTypes = exports.useInternalError = exports.InternalBaseError = exports.BaseError = void 0;
class BaseError extends Error {
    constructor(code, message, options) {
        const _options = {
            code,
            ...(typeof message === 'object' ? message : undefined),
            ...options,
        };
        super(typeof message === 'string' ? message : undefined, _options);
        if (_options.code)
            this.name = _options.code;
    }
    get code() {
        return this.name;
    }
}
exports.BaseError = BaseError;
BaseError.prototype.name = '';
class InternalBaseError extends BaseError {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(...params) {
        super(...params);
    }
    get code() {
        return this.name;
    }
}
exports.InternalBaseError = InternalBaseError;
function useInternalError(table) {
    return class InternalError extends InternalBaseError {
        constructor(...params) {
            super(...params);
            if (!this.name)
                this.name = Object.keys(table)[0] || '';
            if (this.name && !this.message)
                this.message = table[this.name] || '';
        }
    };
}
exports.useInternalError = useInternalError;
function buildErrorCodeTypes(table) {
    return Object.fromEntries(Object.keys(table).map((k) => [k, k]));
}
exports.buildErrorCodeTypes = buildErrorCodeTypes;
exports.InternalErrorTable = {
    unknown: 'Errore interno',
    unexpected: 'Errore inaspettato',
    invalidArg: 'Argomento non valido',
    accessDenied: 'Accesso negato',
    notFound: 'Non trovato',
};
exports.ErrorCode = buildErrorCodeTypes(exports.InternalErrorTable);
exports.InternalError = useInternalError(exports.InternalErrorTable);
//# sourceMappingURL=err.js.map